import { useSelector } from 'react-redux';

const ScreenReaderMessage = () => {
  const cartReducer = useSelector((state) => state.cart);

  if (!cartReducer.cartUpdateMessage) {
    return null;
  }
  return (
    <div
      className="c7-sr-only c7-sr-updates"
      role="status"
      aria-atomic="true"
      aria-live="polite"
      aria-relevant="additions text"
    >
      {cartReducer.cartUpdateMessage}
    </div>
  );
};

export default ScreenReaderMessage;
